import { useEffect, useState } from 'react'


import { Avatar, Card, CardContent, Typography } from "@mui/material";
import '../RusStat/RusStat.css'
import './ParticipantsStatistics.css'
import { IStatisticVote } from './statisticVoteData'
import { ParticipantsItem } from './ParticipantsItem/ParticipantsItem';
import { ParticipantsItemArchive } from './ParticipantsItem/ParticipantsItemArchive';

interface IStatisticVoteProps {
   statisticVote: IStatisticVote[];
}


export const ParticipantsStatistics: React.FC<IStatisticVoteProps> = ({ statisticVote }: any): JSX.Element => {
   const [arrPlayers, setArrPlayers] = useState<IStatisticVote[]>(statisticVote)
   const [sortResult, setSortReasult] = useState([])


   useEffect(() => {
      /* ---------------------- сортировка масива с обьектами перед передачей в рендер--------------------- */
      const sortPerson = () => {
         const personArr = [...arrPlayers]
         let result: any
         result = personArr.map((person: any) => person).sort((a, b) => b.vote - a.vote)
         setSortReasult(result)
      }
      return sortPerson()
   }, [])



   return (
      <Card sx={{ minWidth: 275 }}>
         <CardContent className="participant_stat_card">
            <Typography className='title_stat_participant' variant="h4" gutterBottom>
               Participants of the event#1 from 21/04/2023
            </Typography>
            {sortResult.length <= 0 ? <div className="participant_list position_title">
               <h2>Be the first to participate in our event</h2>
               {/* убрать "archive" с "participant_list_archive" и стили вернутся назад те что были */}
            </div> : (<ul className="participant_list_archive">
               {sortResult.map(({ name, photo, id, vote }: any) => (
                  <ParticipantsItemArchive key={id} name={name} photo={photo} vote={vote} />
               ))
               }
            </ul>)}
         </CardContent>
      </Card >
   )
}

